export default __webpack_public_path__ + "static/media/Inforaphics.5b40dbe3.png";